// ROO-222: cute animal profile avatars, generated with the Gemini image API
// (scripts/gen-avatars.js) and bundled as WebP under src/assets/avatars/<key>.webp.
// Users pick one (no uploads); we store the key on the user and map it to the
// bundled image here. Adding an avatar = drop a <key>.webp in that folder.

/* eslint-disable @typescript-eslint/no-explicit-any */
const ctx = (require as any).context('../assets/avatars', false, /\.webp$/);
const IMAGES: Record<string, string> = {};
ctx.keys().forEach((k: string) => {
  const key = k.replace(/^\.\//, '').replace(/\.webp$/, '');
  IMAGES[key] = ctx(k);
});
/* eslint-enable @typescript-eslint/no-explicit-any */

// Preferred display order for the picker; any extra files append after.
const ORDER = [
  'fox', 'owl', 'panda', 'koala', 'rabbit', 'cat', 'puppy', 'penguin',
  'bear', 'lion', 'tiger', 'frog', 'hedgehog', 'deer', 'monkey', 'kangaroo',
];

export const AVATAR_KEYS: string[] = [
  ...ORDER.filter((k) => k in IMAGES),
  ...Object.keys(IMAGES).filter((k) => !ORDER.includes(k)).sort(),
];

/** Bundled image URL for an avatar key, or null (UI falls back to the initial). */
export function avatarImage(key?: string | null): string | null {
  return (key && IMAGES[key]) || null;
}
